/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './clip.stache';
import can from 'can';
import _ from 'lodash';

Component.extend({
    tag: 'right-rail-clip',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            isActive: {
                type: 'boolean',
                get() {
                    const rounds = this.attr('data.rounds');
                    if (!rounds || rounds.length <= 0) {
                        return false;
                    }

                    const playlistIds = _.flatten(
                        rounds
                            .map((round) =>
                                round.videos.map((it) => it.video.identifier),
                            )
                            .serialize(),
                    );
                    return _.some(this.attr('activeChannels'), (id) =>
                        playlistIds.includes(id),
                    );
                },
            },
            data: {
                type: 'object',
            },
            activeChannel: {
                type: 'string',
                value: null,
            },
            activeChannels: {
                Type: can.List,
                Value: can.List,
            },
            isModalShown: {
                type: 'boolean',
                value: false,
            },
            selectedPlayer: {
                Type: can.Map,
                value: null,
            },
            selectedPlayerFacts: {
                Type: can.List,
                Value: can.List,
            },
            taggedHoles: {
                get() {
                    let holeTags = this.attr('data').holeTags;
                    return holeTags
                        ? holeTags
                              .map((ht) => {
                                  return ht.title;
                              })
                              .join(', ')
                        : '';
                },
            },
        },
        shortenName(name) {
            let nameArr = name.split(' ');
            if (nameArr.length > 1) {
                nameArr[0] = `${nameArr[0].charAt(0)}.`;
                name = nameArr.join('\u00A0');
            }
            return name;
        },
    },
});
